import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import Select from "./common/select";
import http from "../services/http";
import { toast } from "react-toastify";
import UserContext from "../context/userContext";

const ManageGrabbers = () => {
  const [user] = useContext(UserContext);

  const [personal, setPersonal] = useState([]);
  const [categories, setCategories] = useState([]);
  const [shared, setShared] = useState([]);
  const [category, setCategory] = useState("");

  useEffect(() => {
    document.title = "FTR - Manage Grabbers";
    return () => {
      document.title = "FTR";
    };
  }, []);

  useEffect(() => {
    async function getCategories() {
      try {
        const { data } = await http.get(`/report-categories`);
        setCategories(data);
      }
      catch {
        //ignore error
      }
    }
    async function getPersonal() {
      try {
        const { data } = await http.get(`/stored-grabbers/1`);
        setPersonal(data);
      }
      catch {
        //ignore error
      }
    }
    if (user) {
      getCategories();
      getPersonal();
    }
  }, [user]);

  useEffect(() => {
    async function getShared() {
      try {
        const { data } = await http.get(`/stored-grabbers/2/${category}`);
        setShared(data);
      }
      catch {
        //ignore error
      }
    }
    if (category) {
      getShared();
    }
  }, [category, user]);

  async function handleArchiveClick(report, type) {
    if (type === "Personal") {
      setPersonal(personal.filter((p) => p.ID !== report.ID));
    } else {
      setShared(shared.filter((s) => s.ID !== report.ID));
    }

    try {
      await http.delete(`/grabber/${report.ID}`);
      toast.success("Grabber Archived");
    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  return (
    <div className="col mt-4">
      <div className="row">
        <div className="col">
          <h3>Personal Grabbers</h3>
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Name</th>
                <th>Last Updated</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {personal.map((report) => (
                <tr key={report.ID}>
                  <td>
                    <Link to={`/datagrabber/manage/${report.ID}`}>
                      {report.REPORT_NAME}
                    </Link>
                  </td>
                  <td>{moment.utc(report.LAST_UPDATED_DTS).calendar()}</td>
                  <td>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleArchiveClick(report, "Personal")}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {user.MAINTAIN_GRABBERS && (
        <React.Fragment>
          <div className="row">
            <div className="col-auto">
              <h3>Shared Grabbers</h3>
            </div>
            <div className="col-auto">
            <Select
                name="category"
                placeholder="Category"
                value={category}
                options={categories}
                listKey="ID"
                listName="NAME"
                onChange={(e) => {
                  setCategory(e.currentTarget.value);
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Last Updated</th>
                    <th>Updated By</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {shared.map((report) => (
                    <tr key={report.ID}>
                      <td>
                        <Link to={`/datagrabber/manage/${report.ID}`}>
                          {report.REPORT_NAME}
                        </Link>
                      </td>
                      <td>{moment.utc(report.LAST_UPDATED_DTS).calendar()}</td>
                      <td>{report.LAST_UPDATED_BY}</td>
                      <td>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleArchiveClick(report, "Shared")}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default ManageGrabbers;
